import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=fa60034a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa60034a')) {
      api.createRecord('fa60034a', component.options)
    } else {
      api.reload('fa60034a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=fa60034a&", function () {
      api.rerender('fa60034a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cOHALZWSULwj/JS/comp/ImgFallback.vue"
export default component.exports